<script>
import { BModal, BBadge, BFormTextarea } from 'bootstrap-vue'
import Relations from "@core/components/common/changelog/Relations.vue";
import Changes from "@core/components/common/changelog/Changes.vue";
import HamletTable from "@core/components/common/HamletTable.vue";
import ChangesModal from "@core/components/common/changelog/ChangesModal.vue";
import Button from "@core/components/common/Button.vue";

export default {
    name: "ChangesRelationsModal",
    components: {Button, ChangesModal, HamletTable, BModal, Relations, Changes, BBadge, BFormTextarea},
    props: {
        label: {
            default() {
                return this.$t('Component(ChangeLog):changes-label')
            }
        },
        relationsLabel: {
            default() {
                return this.$t('Component(ChangeLog):relations-label');
            }
        },
        changes: {
            required: true,
            default() {
                return [];
            }
        },
        relations: {
            required: true,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                    title: this.$t('Component(Grid):column-title'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'type',
                    label: this.$t('Component(Grid):column-type'),
                    title: this.$t('Component(Grid):column-type'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'oldValue',
                    label: this.$t('Component(Grid):column-old-value'),
                    title: this.$t('Component(Grid):column-old-value'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'newValue',
                    label: this.$t('Component(Grid):column-new-value'),
                    title: this.$t('Component(Grid):column-new-value'),
                    order: 1,
                    active: true,
                },
            ],

            changesToShow: [],
            changesLabel: ''
        };
    },
    methods: {
        fetch(config, callback) {
            const start = config.page * config.perPage - config.perPage;
            let end = start + config.perPage;
            const totalRecords = this.changes.length + this.relations.length;
            if (end > totalRecords) {
                end = undefined;
            }
            callback(
                totalRecords,
                this.changes.concat(this.relations.map(r => {
                    return {
                        subject: r.title,
                        type: 'update',
                        ...r
                    }
                })).slice(start, end)
            );
        },
        showChanges(changelog, label) {
            this.changesToShow = changelog.changes;
            this.changesLabel = changelog.title;
            this.$nextTick(() => {
                this.$refs.changedsssModal.show();
            });
        },
        onRowClick(item) {
            if (item.changeLog && item.changeLog.changes.length > 0) {
                this.showChanges(item.changeLog, item.title);
            }
        },
        show() {
            this.$refs['changes-relations-modal'].show();
        }
    }
}
</script>

<template>
    <b-modal
        ref="changes-relations-modal"
        cancel-variant="outline-secondary"
        body-class="p-0"
        size="xl"
        hide-header
        :ok-title="$t('Component(Button):close')"
        centered
        ok-only
    >
        <ChangesModal
            :label="changesLabel"
            ref="changedsssModal"
            :changes="changesToShow"
        />
        <HamletTable
            card-class="mb-0 pb-0"
            :columns="columns"
            :fetch="fetch"
            @onRowClick="onRowClick"
        >
            <template #header-label>{{ label }}</template>

            <template #cell-title="data">
                <div :class="data.item.changeLog && data.item.changeLog.changes.length ? 'text-decoration-underline' : ''">
                    {{ data.item.subject }}
                </div>
            </template>

            <template #cell-oldValue="data">
                <div v-if="data.item.oldValue">
                    <div v-if="data.item.oldValue.length < 50">{{ data.item.oldValue }}</div>
                    <b-form-textarea
                        v-else
                        readonly
                        rows="3"
                        :value="data.item.oldValue"
                    />
                </div>
            </template>

            <template #cell-newValue="data">
                <div v-if="data.item.newValue">
                    <div v-if="data.item.newValue.length < 50">{{ data.item.newValue }}</div>
                    <b-form-textarea
                        v-else
                        readonly
                        rows="3"
                        :value="data.item.newValue"
                    />
                </div>
            </template>

            <template #cell-type="data">
                <b-badge>{{ data.item.type }}</b-badge>
            </template>
        </HamletTable>
    </b-modal>
</template>
